/* Dawnora sections – progressive enhancement. Every control works without this file. */
(function () {
  'use strict';

  function initGallery(root) {
    var slides = root.querySelectorAll('[data-dn-slide]');
    var thumbs = root.querySelectorAll('[data-dn-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-dn-thumb');
        slides.forEach(function (s) {
          var on = s.getAttribute('data-dn-slide') === i;
          s.classList.toggle('is-active', on);
          var v = s.querySelector('video');
          if (v && !on) { v.pause(); }
        });
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  }

  function initOffer(root) {
    var form = root.querySelector('[data-dn-form]');
    if (!form) return;
    var radios = form.querySelectorAll('input[name="id"]');
    var savings = root.querySelector('[data-dn-savings]');
    var atcs = document.querySelectorAll('[data-dn-atc="' + root.id + '"]');
    var stickyName = document.querySelector('[data-dn-sticky-name="' + root.id + '"]');
    function update() {
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      radios.forEach(function (x) { x.closest('.dn-bar').classList.toggle('is-selected', x === r); });
      if (savings) savings.textContent = r.getAttribute('data-savings') || '';
      var soldOut = r.getAttribute('data-available') !== 'true';
      atcs.forEach(function (b) {
        b.textContent = soldOut ? b.getAttribute('data-sold-out') : b.getAttribute('data-label') + ' · ' + r.getAttribute('data-price');
        b.disabled = soldOut;
      });
      if (stickyName) stickyName.textContent = r.getAttribute('data-sticky');
    }
    radios.forEach(function (x) { x.addEventListener('change', update); });
    update();

    var sticky = document.querySelector('[data-dn-sticky="' + root.id + '"]');
    var mainBtn = root.querySelector('[data-dn-main-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      }).observe(mainBtn);
    }
  }

  function initCheck(root) {
    var boxes = root.querySelectorAll('input[type="checkbox"]');
    var out = root.querySelector('[data-dn-check-result]');
    if (!out) return;
    var msgs = [out.getAttribute('data-r0'), out.getAttribute('data-r1'), out.getAttribute('data-r2')];
    function update() {
      var n = 0;
      boxes.forEach(function (b) { if (b.checked) n++; });
      out.textContent = n === 0 ? msgs[0] : (n <= 2 ? msgs[1] : msgs[2]);
    }
    boxes.forEach(function (b) { b.addEventListener('change', update); });
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-dn-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-dn-offer]').forEach(initOffer);
    (scope || document).querySelectorAll('[data-dn-checklist]').forEach(initCheck);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); }
  else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
